import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'

import CustomIcon from '../../CustomIcon'

const StarCircleIcon = createIcon({
  displayName: 'StarCircleIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g
        xmlns="http://www.w3.org/2000/svg"
        strokeLinecap="round"
        strokeWidth="1.5"
        stroke="currentColor"
        fill="none"
        strokeLinejoin="round"
      >
        <path d="M10.459 16.133l1.067-.561c.297-.156.652-.156.949 0l1.067.561c.344.181.76.151 1.074-.078l.398-.289c.314-.228.471-.615.406-.997l-.204-1.188c-.057-.331.053-.668.293-.903l.863-.841c.278-.271.378-.676.258-1.045l-.152-.468c-.12-.369-.439-.638-.823-.694l-1.193-.173c-.332-.048-.619-.257-.768-.558l-.534-1.081c-.171-.348-.526-.568-.914-.568h-.492c-.388 0-.743.22-.914.568l-.533 1.081c-.149.301-.436.51-.768.558l-1.193.173c-.384.056-.703.325-.823.694l-.152.468c-.12.369-.02.774.258 1.045l.863.841c.24.234.35.572.293.903l-.204 1.188c-.066.383.092.769.406.997l.398.289c.314.228.73.258 1.074.078Z" />
        <path d="M5.636 5.636c3.515-3.515 9.213-3.515 12.728 0 3.515 3.515 3.515 9.213 0 12.728 -3.515 3.515-9.213 3.515-12.728 0 -3.515-3.515-3.515-9.213-8.88178e-16-12.728" />
      </g>
      <path xmlns="http://www.w3.org/2000/svg" fill="none" d="M0 0h24v24h-24v-24Z" />
    </>
  ),
})

const StarCircle: FC<IconProps> = (props) => {
  return <CustomIcon as={StarCircleIcon} {...props} />
}

export default memo(StarCircle)
